module.exports = __webpack_public_path__ + "img/Icon_MoreSetting.155bf8d1.png";